import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useRouter } from 'next/router';
import Button from '@mui/material/Button';

// Listens for upload failures emitted by helpers/imageUpload.js and surfaces
// them. A storage-quota hit gets a persistent snackbar with an Upgrade CTA
// (→ /dashboard/upgrade); any other upload error gets a transient error toast.
// Mounted once in _app.js so every upload entry point gets consistent feedback
// without each call site re-implementing it.
const ImageQuotaNotifier = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const router = useRouter();

  useEffect(() => {
    const handler = event => {
      const { message, quota } = (event && event.detail) || {};
      if (quota) {
        enqueueSnackbar(
          message || 'You have reached your image storage limit.',
          {
            variant: 'warning',
            persist: true,
            action: key => (
              <>
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    closeSnackbar(key);
                    router.push('/dashboard/upgrade');
                  }}
                >
                  Upgrade
                </Button>
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => closeSnackbar(key)}
                >
                  Dismiss
                </Button>
              </>
            ),
          },
        );
      } else {
        enqueueSnackbar(message || 'Image could not be uploaded', {
          variant: 'error',
        });
      }
    };
    window.addEventListener('tf:image-upload-error', handler);
    return () => window.removeEventListener('tf:image-upload-error', handler);
  }, [enqueueSnackbar, closeSnackbar, router]);

  return null;
};

export default ImageQuotaNotifier;
